import {
  AlleyPinConfig,
  Appointment,
  AppointmentConfig,
  AppointmentSchedule,
  Menu,
} from "@ambii-com/core";
import {
  liteCollections,
  liteGetDocument,
  liteGetVacantSchedules,
  liteQueryCollection,
  liteQueryCollectionWith,
} from "~/utils/firestoreLite";

export async function readAppointmentsByUserId(
  userId: string
): Promise<Appointment[]> {
  const docs = await liteQueryCollectionWith(
    liteCollections.scheduleAppointments,
    ["userId", "==", userId]
  );
  return Appointment.fromDocs(docs);
}

export async function readAppointmentConfig(
  appointmentConfigId: string
): Promise<AppointmentConfig> {
  return liteGetDocument(liteCollections.appointmentConfigs, appointmentConfigId).then(
    AppointmentConfig.fromDoc
  );
}

export async function readMenu(menuId: string): Promise<Menu> {
  return liteGetDocument(liteCollections.appointmentMenus, menuId).then(Menu.fromDoc);
}

export async function readSchedule(scheduleId: string): Promise<AppointmentSchedule> {
  return liteGetDocument(liteCollections.appointmentSchedules, scheduleId).then(
    AppointmentSchedule.fromDoc
  );
}

export async function readSchedulesForMenu(menuId: string): Promise<AppointmentSchedule[]> {
  const [legacyDocs, containsDocs] = await Promise.all([
    liteQueryCollection(liteCollections.appointmentSchedules, "resourceId", menuId),
    liteQueryCollectionWith(
      liteCollections.appointmentSchedules,
      ["resourceId", "array-contains", menuId]
    ),
  ]);
  return AppointmentSchedule.fromDocs([...legacyDocs, ...containsDocs]);
}

export async function readSchedulesForMenuFromDate(menuId: string, date: Date): Promise<AppointmentSchedule[]> {
  const docs = await liteQueryCollectionWith(
    liteCollections.appointmentSchedules,
    ["resourceId", "array-contains", menuId],
    ["startDatetime", ">=", date]
  )
  return AppointmentSchedule.fromDocs(docs)
}

export async function readAlleyPinConfig(
  alleyPinConfigId: string
): Promise<AlleyPinConfig> {
  return liteGetDocument(liteCollections.alleyPinConfigs, alleyPinConfigId).then(
    AlleyPinConfig.fromDoc
  );
}

export async function readMenusForClinic(clinicId: string): Promise<Menu[]> {
  const docs = await liteQueryCollectionWith(
    liteCollections.appointmentMenus,
    ["clinicId", "==", clinicId],
    ["available", "==", true]
  );
  return Menu.fromDocs(docs);
}

export async function readVacantSchedules(
  menuId: string
): Promise<AppointmentSchedule[]> {
  const docs = await liteGetVacantSchedules(menuId);
  return AppointmentSchedule.fromDocs(docs);
}
